import { useTranslation } from 'react-i18next'

import type { ErrorComponentProps } from '@tanstack/react-router'

export function ErrorFallback({ error }: ErrorComponentProps) {
  const { t } = useTranslation()
  return (
    <div className="flex flex-col items-center justify-center min-h-[200px] p-6">
      <h2 className="text-xl font-bold text-red-600 mb-2">
        {t('errorFallback.title')}
      </h2>
      <pre className="text-red-500">{error.message}</pre>
    </div>
  )
}
